export default __webpack_public_path__ + "static/media/subscribe-background.dcba9c95.png";